export const ACCOUNT_NUMBER_TO_CUSTOMER = {
    4077535: 'AMAZON',
    3660949: 'WAYFAIR',
    3467680: 'BEST BUY',
    4647582: 'TARGET',
    2070948: 'SAMS',
    3610704: 'COSTCO',
    3358394: 'LOWES',
    109797228: 'HOME DEPOT',
    // CROSLEY?
}

export const NCRP_ENABLED_SALES_AGREEMENT_TYPES = ['STANDARD AGREEMENT', 'INVENTORY FINANCING'];


// WEBPACK FOOTER //
// ./src/App/components/common/ncrpConstants.js